import { Record } from 'immutable';
import { SUPPLIER_OPTION } from 'commons-vehicle/constants/dataTypes.js';

const ColourRecord = Record({
    colourCode: '',
    colourDescription: '',
    fabricDescription: '',
    selected: false,
    enabled: true,
    visible: true,
    colourTile: '',
    photo1: '',
    photo2: '',
    photo3: '',
    retail: 0,
    residualRetail: 0,
});

class Colour extends ColourRecord {
    getColourCode() {
        return this.get('colourCode');
    }

    getColourSelectionCode() {
        return `${this.colourCode}>${SUPPLIER_OPTION}`;
    }
}

export default Colour;
